import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchMe } from 'store/slices/authSlice'
import { hasPermUser } from 'utils/permissions'
import { Result } from 'antd'
import Loading from 'components/shared-components/Loading'

export default function RequirePerm({ perm, children }) {
  const dispatch = useDispatch()
  const { token, user, userLoading } = useSelector((s) => s.auth)

  useEffect(() => {
    if (token && !user && !userLoading) dispatch(fetchMe())
  }, [token, user, userLoading, dispatch])

  if (!perm) return children

  // ✅ enquanto carrega, mostra loader (em vez de tela vazia)
  if (!user) return <Loading cover="content" />

  if (!hasPermUser(user, perm)) {
    return <Result status="403" title="Sem permissão" subTitle="Você não tem acesso a esta página." />
  }

  return children
}
